import React from 'react';
import { Helmet } from 'react-helmet-async';
import ServiceRequestsTab from '../../components/admin/requests/ServiceRequestsTab';

export default function ServiceRequests() {
  return (
    <>
      <Helmet>
        <title>Service Requests | Admin</title>
      </Helmet>

      <div className="space-y-6">
        <h1 className="text-2xl font-bold text-gray-900">Service Requests</h1>
        <ServiceRequestsTab />
      </div>
    </>
  );
}